import axios from "axios";
import { LoaderFunctionArgs, redirect } from "react-router-dom";
import { REACT_APP_BACKENDURL } from "../../../config";
import { defaultSettings } from "../../../contexts/appsettings/defaultSettings";
import { HierarchyLoaderReturn } from "../hierarchy/hierarchyLoader";
import { addColumnInformation } from "./addColumnInformation";
import { TlfItemReadDto } from "./TlfItemReadDto";
import { TlfLoaderData } from "./tlfLoader";

/**
 * Loader for creating a new TLF item page.
 *
 * @param props - Loader args provided by react-router
 * @param props.params - Route params used to determine new TLF type and hierarchy
 * @returns Data required to render the new TLF page
 */
export const newTlfLoader = async ({ params }: LoaderFunctionArgs) => {
  const backEndUrl = REACT_APP_BACKENDURL.includes("_REACT_APP_BACKENDURL_")
    ? defaultSettings.backEndUrl
    : REACT_APP_BACKENDURL;

  if (!params.newType) return redirect("/NotFound");

  const hierarchyTag =
    params.hierarchyTag !== undefined
      ? params.hierarchyTag
      : params.studyName !== undefined && params.reportName !== undefined
        ? `Report/${params.studyName}/${params.reportName}`
        : "Corporate";

  const requests = await Promise.all([
    axios.get(`${backEndUrl}NewTlfItems/${params.newType}`),
    axios.get(`${backEndUrl}Hierarchy/Loader/${hierarchyTag}`),
  ]);
  const newTlfItem = requests[0]?.data as TlfItemReadDto;
  const hierarchyLoader = requests[1]?.data as HierarchyLoaderReturn;

  if (!newTlfItem || !hierarchyLoader.hierarchy) return redirect("/NotFound");
  const isHierarchySubscribed = (
    await axios.get(
      `${backEndUrl}Comments/Hierarchy/${hierarchyLoader.hierarchy.id}/GetSubscriptionStatus`,
    )
  ).data as boolean;

  newTlfItem.azsolId = "";
  newTlfItem.primaryHierarchyId = hierarchyLoader.hierarchy.id;
  newTlfItem.primaryHierarchyName = hierarchyLoader.hierarchy.name;
  newTlfItem.primaryHierarchyLevel = hierarchyLoader.hierarchy.level;
  newTlfItem.primaryHierarchyType = hierarchyLoader.hierarchy.type;
  newTlfItem.id = params.newType;

  // Ensure columnIds and columnInformation for new TLF items
  /* istanbul ignore else */
  if ("bodyData" in newTlfItem.body && "headerData" in newTlfItem.body) {
    newTlfItem.body = addColumnInformation(newTlfItem.body);
  }

  const ret: TlfLoaderData = {
    tlfItem: newTlfItem,
    hierarchy: hierarchyLoader.hierarchy,
    parentHierarchies: hierarchyLoader.parentHierarchies,
    accessRights: hierarchyLoader.accessRights,
    isHierarchySubscribed: isHierarchySubscribed,
    isTlfSubscribed: false,
  };
  return ret;
};
